
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCountry, selectDelivery, selectShowInvalids } from '@store/order/selectors';
import { setDelivery } from '@store/order/slice';
import Checkbox from '@components/checkbox/Checkbox';
import { invalidFormValue } from '@components/utils';
import { useLazyGetDeliveryTypesQuery } from '@api/baseApi';
import { DeliveryTypeDef } from '@api/types/DeliveryTypeDef';
import { CountryEnum } from '@api/types/CountryEnum';



const Shipping = (): JSX.Element => {

	const country = useSelector(selectCountry);
	const delivery = useSelector(selectDelivery);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateDelivery = (value: DeliveryTypeDef | null) => dispatch(setDelivery(value));

	const [ getDeliveryTypes, { data, isLoading, isFetching, isError, isSuccess } ] = useLazyGetDeliveryTypesQuery();

	useEffect(() => {
		if (country) {
			getDeliveryTypes({ country }, true);
		}
	}, [ country ]);

	return (
		<div className='shipping-section'>

			<label className='shipping-label'>
				Doprava <span>*</span> {showInvalids && invalidFormValue(delivery) &&
					<p className='form-invalid'>Povinné pole</p>}
			</label>

			{isError &&
				<p className='error-message'>Chyba při načítání</p>}

			{(isLoading || isFetching) &&
				<p className='loading-message'>Načítám...</p>}

			{isSuccess && data && data.length === 0 &&
				<p className='info-message'>Žádná doprava k dispozici</p>}

			{isSuccess && data && data.length > 0 && data.map(x =>
				<Checkbox isSelected={delivery !== null && delivery.id === x.id} onChange={() => updateDelivery(x)} isRequired={true} key={`order-form-delivery-${x.id}`}>
					{`${x.description} (${
						x.price === 0
						? 'ZDARMA'
						: country === CountryEnum.sk
						? `${x.price} \u20AC`
						: `${x.price} Kč`})`}
				</Checkbox>)}
		</div>
	);
};

export default Shipping;